/**
 * Binary search function to made some fast research in an array of object
 * !!! the array need to be order from lower value to upper value
 * This version made specially for string comparaison
 * @param {*} array 
 * @param {*} string 
 * @param {*} property 
 * @returns 
 */


// Todo for some impovements who can replace de [property] by the resolveObject function who will allow you to search for deep dependencies
function binarySearchString(array, string, property = 'object_id') {
    var min = 0;
    var max = array.length;
    if(max == 0) return null;
    if(strcmp(string, array[min][property]) == 0) return min;

    if(strcmp(string, array[max - 1][property]) == 0) return max - 1;

    // See somme documentation on internet for a full explanation of binarySearch
    while(min <= max) {
        let m = min + Math.floor((max - min) / 2);
        if(m == 0) {
            return null;
        }

        let res = strcmp(string, array[m - 1][property]);
        if(res == 0) {
            return m - 1
        }
        else if (res > 0 ){
            min = m + 1;
        }
        else {
            max = m - 1;
        }
    }

    return null;
}

// We compare two string, if they are equals return else if the second if lower than the first we return 1 other -1
const strcmp = ( str1, str2 ) => ( ( str1 == str2 ) ? 0 : ( ( str1 > str2 ) ? 1 : -1 ) );

export default binarySearchString;